import { api } from "./apiClient";

export const brandService = {
  list: async () => (await api.get("/admin/brands")).data,
  create: async (name) => (await api.post("/admin/brands", { name })).data,
  update: async (id, payload) => (await api.patch(`/admin/brands/${id}`, payload)).data,
  remove: async (id) => (await api.delete(`/admin/brands/${id}`)).data,
  brandClients: async (id) => (await api.get(`/admin/brands/${id}/clients`)).data,
  unassigned: async (search = "") =>
    (await api.get("/admin/brands/unassigned/clients", { params: { search } })).data,
  assign: async (brandId, userIds) =>
    (await api.post(`/admin/brands/${brandId || "none"}/assign`, { user_ids: userIds })).data,
  mine: async () => (await api.get("/branding/me")).data,
};
